<template>
  <div style="width:100%">
    <el-header  style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
    <el-main>
      <Table :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="true" :showEditButton="true"  
            @sync-delete="deleteSysValueDtl" @sync-save="saveSysValueDtl" @reload-data-by-sort="reloadDataBySort"/> 
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import Table from '../components/EditableTable'

import {apiFindAllSysValueMainData, apiFindAllSysValueDtlData, apiSaveSysValueDtlData, apiDeleteSysValueDtlDataById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'sysValueDetailManagement',
  data() {
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "parentCategory", title: "Category", width: 240, required:true, type:'select', notUpdate:true},
          { field: "attribute", title: "Attribute", width: 150 , required:true },
          { field: "value", title: "Value", width: 120, required:false },
          { field: "enabledStr", title: "Enabled", width: 100 , required:true, type:'select' },
          { field: "sortOrder", title: "Sort Order", width: 120 , required:false },
          { field: "description", title: "Description", required:false }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'sysValueDtlTable',
        exportName: this.$i18n.t('menu.sysValueDetailManagagement')        
      },
      sortColumn:'',
      sortType:'',
    };
  },
  components: {
    Breadcrumb,
    Table
  },
  mounted() {    
    this.readData();
  },
  created(){
      this.tableData.columns.forEach((item) => {
        if(item.field == 'parentCategory'){
          apiFindAllSysValueMainData({ headers: authHeader(), sortColumn:this.sortColumn, sortType:this.sortType  }).then((response) => {  
            item.selectObj = [];
            response.data.forEach((item2, index) => {   
              item.selectObj.push({ value: item2.id, label: item2.category });
            });
          }).catch((err) => {
            console.log(err);
          });          
          //item.selectObj = [{value:'1',label:'Y'},{value:'0',label:'N'}];
        }
        if(item.field == 'enabledStr'){
          item.selectObj = [{value:'Y',label:'Y'},{value:'N',label:'N'}];
        }
      });
  },
  methods: {
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindAllSysValueDtlData({ headers: authHeader(),  sortColumn:this.sortColumn, sortType:this.sortType  }).then((response) => { 
        response.data.forEach((item, index) => { 
          item.enabledStr = (item.enabled==0?'N':'Y');
        });              
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveSysValueDtl(data){
      //debugger
      if(data.length == null){
        data = [data];
      }
      data.forEach((item, index) => { 
         if(item.parentId == null) item.parentId = item.parentCategory;
         item.enabled = ((item.enabledStr=='Y'||item.enabledStr=='1')?1:0);
      });
      apiSaveSysValueDtlData({  headers: authHeader(), dtlList : data}).then((response) => {                    
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {
        if(err.response.data.message != null && err.response.data.message != ''){
          this.$message.error({message:err.response.data.message, duration: 1000});
        }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }        
        console.log(err);
      });
    },
    deleteSysValueDtl(data){           
      apiDeleteSysValueDtlDataById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.readData()
    } 
  }
};
</script>